import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GenericHttpService } from './generic-http.service';
import { Observable, map } from 'rxjs';

export interface ProcurementNote {
  id?: number | string;
  note: string;
  attachments: ProcurementNoteAttachment[];
}

export interface ProcurementNoteAttachment {
  name: string;
  url: string;
  isImage: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PreProcurementService {
  baseEndPoint;

  constructor(
    public genericHttpService: GenericHttpService,
    private httpclient: HttpClient
  ) {
    this.baseEndPoint = environment.apiURL;
  }

  getCessDetails(queryParams?) {
    return this.genericHttpService.Get(
      '/payment/calculate-amount/?' + queryParams
    );
  }


  calculateAmountBulk(data: any[]): Observable<any> {
  const endPoint =
    this.baseEndPoint + '/payment/calculate-amount-bulk/';

  return this.httpclient.post(endPoint, data);
}

  getProcurmentDetails(queryParams?: object): Observable<any> {
    let endPoint = this.baseEndPoint + '/payment/procrument-bulk/';
    if (queryParams) {
      endPoint += this.genericHttpService.getQueryString(queryParams);
    }
    return this.httpclient.get(endPoint);
  }
  // getProcurmentDetails() {
  //   return this.genericHttpService.Get('/payment/procrument-bulk/');
  // }
  getProcurementById(queryParams?: object): Observable<any> {
    let endPoint = this.baseEndPoint + '/payment/procrument-details/';
    if (queryParams) {
      endPoint += this.genericHttpService.getQueryString(queryParams);
    }
    return this.httpclient.get(endPoint);
  }

  getPreProcurementNotes(preProcurementId: string | number): Observable<ProcurementNote[]> {
    const params = new HttpParams().set('pre_procurement_id', preProcurementId);
    return this.httpclient
      .get<any>(`${this.baseEndPoint}/payment/pre-procurement-notes/`, { params })
      .pipe(
        map((response) => {
          const records = Array.isArray(response)
            ? response
            : response?.content ?? response?.results ?? response?.data;

          if (!Array.isArray(records)) {
            throw new Error('Unexpected pre-procurement notes response.');
          }

          return records.map((record): ProcurementNote => {
            const rawImages = record?.images ?? record?.image ?? record?.image_url ?? [];
            const imagePaths = (Array.isArray(rawImages) ? rawImages : [rawImages])
  .flatMap((image: any) => {
    const imagePath =
      typeof image === 'string'
        ? image
        : image?.url ?? image?.image_url ?? image?.file_url;

    if (typeof imagePath !== 'string') {
      return [];
    }

    // Backend can return either:
    // 1. Array of complete data URLs
    // 2. Comma-separated file paths
    if (imagePath.startsWith('data:')) {
      return [imagePath.trim()];
    }

    return imagePath
      .split(',')
      .map((path: string) => path.trim())
      .filter((path: string) => path.length > 0);
  });
            const baseUrl = this.baseEndPoint.replace(/\/+$/, '');
     const attachments = imagePaths.map((path: string, index: number) => {
  const isDataUrl = path.startsWith('data:');

  const name = isDataUrl
    ? `Attachment ${index + 1}`
    : path.split('/').pop() ?? `Attachment ${index + 1}`;

  const extension = name.split('.').pop()?.toLowerCase();

  const isImage =
    path.startsWith('data:image/') ||
    ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension ?? '');

  return {
    name,
    url: isDataUrl
      ? path
      : `${baseUrl}/${path.replace(/^\/+/, '')}`,
    isImage,
  };
});

            return {
              id: record?.id,
              note: record?.notes ?? record?.note ?? record?.description ?? '',
              attachments,
            };
          });
        }),
      );
  }
  // getProcurementById(id: string){
  //   return this.genericHttpService.Get('/payment/procrument-details/?id='+id);
  // }

  createProcurmentOrder(data: any) {
    let endPoint = this.baseEndPoint + '/payment/procrument-details/';
    return this.httpclient.post(endPoint, data);
  }

  getStampTypeByState(id: string) {
    let endPoint =
      this.baseEndPoint + '/estamp/state-stamp-type/?state_code=' + id;
    return this.httpclient.get(endPoint);
  }

  getArticles(queryParams?: object): Observable<any> {
    let endPoint = this.baseEndPoint + '/articles/';
    if (queryParams) {
      endPoint += this.genericHttpService.getQueryString(queryParams);
    }

    return this.httpclient.get(endPoint);
  }


  getReviewerData(account_id: any): Observable<any> {
    let endPoint = this.baseEndPoint + `/payment/validate-pre-procurement-reviewers/?account_id=${account_id}`;
    return this.httpclient.get(endPoint);
  }

  getApproveOrder(data: any) {
    let endPoint =
      this.baseEndPoint + '/payment/pre-procurement-order-approve/';
    return this.httpclient.post(endPoint, data);
  }

  getPreProcurmentCount(queryParams?: object): Observable<any> {
    let endPoint = this.baseEndPoint + '/payment/pre-procurement-status/';
    if (queryParams) {
      endPoint += this.genericHttpService.getQueryString(queryParams);
    }
    return this.httpclient.get(endPoint);
  }

  ExportProcurmentReport(queryParams?: object): Observable<any> {
    let endPoint = this.baseEndPoint + '/payment/pre-procurement-report/';
    if (queryParams) {
      endPoint += this.genericHttpService.getQueryString(queryParams);
    }
    return this.httpclient.get(endPoint);
  }
}